module.exports = __webpack_public_path__ + "media/images/target-logo-146e6b15afa9cf24a5936ae374da2752.svg";